// Intent detection patterns for Remy's cellar mode switching.

const CELLAR_INTENT_PATTERNS = [
  /\bdo i have\b/i,
  /\bin my (cellar|cave|collection|rave cave)\b/i,
  /\bmy (reds|whites|bottles|wines|collection)\b/i,
  /\bwhat('s| is) in\b/i,
  /\badd (this|it|a bottle)\b/i,
  /\bdrink tonight\b/i,
  /\brecommend (from|out of) my\b/i,
  /\bhow many (do i|bottles)\b/i,
  /\bmy inventory\b/i,
  /\bcheck (my|the) (cellar|cave)\b/i,
  /\bsomething (similar|like that) (in|from) my\b/i,
];

const AFFIRMATIVE_PATTERNS = [/^(yes|yeah|sure|yep|ok|okay|go ahead|do it|please)[\s!.]*$/i];

export function detectCellarIntent(message: string): boolean {
  return CELLAR_INTENT_PATTERNS.some(pattern => pattern.test(message));
}

export function isAffirmative(message: string): boolean {
  return AFFIRMATIVE_PATTERNS.some(p => p.test(message.trim()));
}

/**
 * ANTI-GAP CHUNKING:
 * Splits text into small, manageable chunks for back-to-back queueing.
 */
export const chunkText = (text: string): string[] => {
  const chunks: string[] = [];
  // Split primarily on sentence boundaries
  const sentences = text.match(/[^.!?]+[.!?]+|[^.!?]+$/g) || [text];

  for (let sentence of sentences) {
    sentence = sentence.trim();
    if (!sentence) continue;

    // Sub-split if sentence is too long (> 160 chars)
    if (sentence.length > 160) {
      const parts = sentence.split(/([,;:])/).filter(p => p.trim().length > 0);
      let currentPart = "";
      for (const p of parts) {
        if ((currentPart + p).length > 220) {
          chunks.push(currentPart.trim());
          currentPart = p;
        } else {
          currentPart += p;
        }
      }
      if (currentPart) chunks.push(currentPart.trim());
    } else {
      chunks.push(sentence);
    }
  }
  return chunks;
};
